import { render } from "./Notfound.vue?vue&type=template&id=f82767a2&scoped=true"
import script from "./Notfound.vue?vue&type=script&lang=ts"
export * from "./Notfound.vue?vue&type=script&lang=ts"

import "./Notfound.vue?vue&type=style&index=0&id=f82767a2&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-f82767a2"

export default script